export enum Strategy
{
    CUSTOM="Custom",
    CURRENT_DAY="CurrentDay",
    DAILY="Daily",
    DFA="DFA",
    MONTHLY="Monthly",
    YESTERDAY="Yesterday"

}